module.exports = __webpack_public_path__ + "static/media/Glatt.56f77973.PNG";